$ = jQuery.noConflict();

$(() => {

	setMasks();

	function setMasks() {
		var SPMaskBehavior = function (val) {
		    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
		}, spOptions = {
		    onKeyPress: function(val, e, field, options) {
		        field.mask(SPMaskBehavior.apply({}, arguments), options);
		    }
		};

		$('.rg-mask').keyup(function() {
  			this.value = this.value.toUpperCase();
		});

		$('.quantidade').mask('#.##0', {reverse: true}); $('.qtd').mask('#.##0',
		{reverse: true}); $('.money').maskMoney({thousands:'.', decimal:','});
		$('.money-four').mask('#.##0,0000', {reverse: true});
		$('.date-mask').mask('00/00/0000'); $('.cep-mask').mask('00000-000');
		$('.phone-mask').mask('(00) 0000-0000');
		$('.cellphone-mask').mask(SPMaskBehavior, spOptions);
		$('.cnpj-mask').mask('00.000.000/0000-00', {reverse: true});
		$('.cpf-mask').mask('000.000.000-00', {reverse: true});
		$('.rg-mask').mask('ZZ00.000.000-A', { translation: { 
			'Z': { pattern:
		/[A-Za-z]/, optional: true },
		'A': {pattern: /[A-Za-z0-9]/}, } });

	var options =  {
		  onKeyPress: function(numero, e, field, options) {
		    var masks = ['000,00', '000,00'];
		    var mask = (numero.length > 5) ? masks[1] : masks[0];
		    $('.npk').mask(mask, options);
		    if(numero.length > 5) {
		    	field[0].value = "100,00";
		    }
			},
			reverse: true
	};

		$('.npk').mask('000,00', options);
	}


	$('#block-agd-content form').on("DOMNodeInserted", function() {
		setMasks();
	});

	$('#block-agd-content').on("DOMNodeInserted", function() {
		setMasks();
	});


	$(document).ready(function() {
		$('#block-agd-content').css('display', 'block');
	});


});


